document.addEventListener('DOMContentLoaded', () => {
  const quitAcceptCheckboxes = document.querySelectorAll('.js-quit-accept')
  quitAcceptCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const notCheckedCheckboxes = document.querySelectorAll('.js-quit-accept:not(:checked)')
      const quitSubmitButton = document.querySelector('.js-quit-submit') as HTMLButtonElement
      quitSubmitButton.disabled = notCheckedCheckboxes.length !== 0
    })
  })
})
